class Debug {
  constructor() {
    this.activeLevel = 'OFF'
    this.logLevels = { HIGHLIGHT: 0 }
    this.logLevelConfigs = [{ name: 'HIGHLIGHT', color: 'black', value: 0 }]
    this.init = this.init.bind(this)
    this.log = this.log.bind(this)
    this.logObject = this.logObject.bind(this)
    this.groupStart = this.groupStart.bind(this)
    this.groupEnd = this.groupEnd.bind(this)
    this.groupCollapsed = this.groupCollapsed.bind(this)
  }
  init(config = {}) {
    this.activeLevel = 'OFF'
    this.logLevels = {}
    this.logLevelConfigs = [
      { name: 'HIGHLIGHT', color: 'black', value: 0 },
      ...config.logLevels
    ].map((levelConfig, idx) => {
      this.logLevels[levelConfig.name] = idx
      return {
        ...levelConfig,
        value: idx
      }
    })
    const { activeLevel = 'OFF' } = config
    switch (activeLevel.toUpperCase()) {
      case 'ALL':
      case 'OFF':
        this.activeLevel = activeLevel.toUpperCase()
        break
      default:
        this.activeLevel = this.logLevels[config.activeLevel] || 'OFF'
    }
  }
  log(message, level, type = 'log', css = '') {
    const { color, section } = levelToColorSection(level, this.logLevelConfigs)
    const DebugString =
      typeof this.activeLevel === 'string' ? this.activeLevel.toLowerCase() : ''
    const finalMessage = '%c ' + section + ' %c' + message
    if (level === this.logLevels.HIGHLIGHT) {
      css = 'background-color: yellow;' + css
    }

    if (
      this.activeLevel === level ||
      DebugString === 'all' ||
      DebugString === 'capture'
    ) {
      switch (type.toLowerCase()) {
        case 'error':
          console.error(finalMessage, 'color: ' + color, 'color: red;' + css)
          break
        case 'info':
          console.info(finalMessage, 'color: ' + color, 'color: blue;' + css)
          break
        case 'warn':
          console.warn(finalMessage, 'color: ' + color, 'color: orange;' + css)
          break
        case 'alert':
          alert(section + '\n' + JSON.stringify(message))
          break
        default:
          console.log(finalMessage, 'color: ' + color, 'color: black;' + css)
      }
    }
  }
  logObject(message, object, level, type = 'log', css = '') {
    const { color, section } = levelToColorSection(level, this.logLevelConfigs)
    const DebugString =
      typeof this.activeLevel === 'string' ? this.activeLevel.toLowerCase() : ''
    const finalMessage = '%c ' + section + ' %c' + message + '\n %o'
    if (level === this.logLevels.HIGHLIGHT) {
      css = 'background-color: yellow;' + css
    }
    if (
      this.activeLevel === level ||
      DebugString === 'all' ||
      DebugString === 'capture'
    ) {
      switch (type.toLowerCase()) {
        case 'error':
          console.error(
            finalMessage,
            'color: ' + color,
            'color: red;' + css,
            object
          )
          break
        case 'info':
          console.info(
            finalMessage,
            'color: ' + color,
            'color: blue;' + css,
            object
          )
          break
        case 'warn':
          console.warn(
            finalMessage,
            'color: ' + color,
            'color: orange;' + css,
            object
          )
          break
        case 'alert':
          alert(section + '\n' + JSON.stringify(message))
          break
        default:
          console.log(
            finalMessage,
            'color: ' + color,
            'color: black;' + css,
            object
          )
      }
    }
  }
  groupStart(message, level) {
    this.groupCollapsed(message, level)
  }
  groupCollapsed(message, level) {
    const { color, section } = levelToColorSection(level, this.logLevelConfigs)
    const DebugString =
      typeof this.activeLevel === 'string' ? this.activeLevel.toLowerCase() : ''
    const finalMessage = '%c ' + section + '%c ' + message

    if (
      this.activeLevel === level ||
      DebugString === 'all' ||
      DebugString === 'capture'
    ) {
      console.groupCollapsed(finalMessage, 'color: ' + color, 'color: black;')
    }
  }
  groupEnd(level) {
    let DebugString = ''
    if (typeof this.activeLevel === 'string') {
      DebugString = this.activeLevel.toLowerCase()
    }
    if (
      this.activeLevel === level ||
      DebugString === 'all' ||
      DebugString === 'capture'
    ) {
      console.groupEnd()
    }
  }
}

export const levelToColorSection = (level, logLevelConfigs = []) => {
  let config = logLevelConfigs.find(levelConfig => levelConfig.value === level)
  config = config === undefined ? {} : config
  const { color = 'black', name = 'unknown' } = config

  return { color, section: `(${name})` }
}

const debug = new Debug()
export default debug
